<template>
    <div
        class="l-ss-c-offer-image-container"
        ref="imgWrapper">
        <div class="l-ss-c-offer-image-wrapper">
            <img
                class="l-ss-c-offer-image"
                :class="{ 'l-ss-c-offer-image-adult': isAdult }"
                @error="errorImgListener"
                :src="offerImages[currentImageIndex]"
                :style="style">
            <slot></slot>

            <div
                v-if="isAdult"
                class="l-ss-c-offer-image-adult-overlay">
                <i v-html="iconEyeSlash"></i>
                <span>Товар для взрослых</span>
            </div>
        </div>
        <div
            class="l-ss-c-offer-image-indicators"
            v-if="vertical || (!vertical && offerImages.length > 1)">
            <template v-if="offerImages.length > 1">
                <span
                    v-for="imgIndex in offerImages.length"
                    :key="imgIndex"
                    ref="indicator"
                    :data-index="imgIndex - 1"
                    class="l-ss-c-offer-image-indicator"
                    :class="{ 'l-ss-c-offer-image-indicator-active': currentImageIndex === imgIndex - 1 }"></span>
            </template>
        </div>
    </div>
</template>

<script>
    import { ref } from '@/lib/vue-composition-api.js';

    import iconLike from '@/core/assets/images/icons/like.svg';
    import iconEyeSlash from '@/core/assets/images/icons/eye-slash.svg';

    import useImageController from '@/core/components/offer/offer-image/use-image-controller';

    export default {
        name: 'offer-image',
        props: {
            offer: {
                type: Object,
            },
            settings: {
                type: Object,
            },
            mobile: {
                type: Boolean,
                default: false,
            },
            vertical: {
                type: Boolean,
                default: false,
            },
            isAdult: {
                type: Boolean,
                default: false,
            },
        },
        setup(props, { refs }) {
            const { settings } = props;
            const { style } = settings;
            const images = props.offer.pictures || [];

            const { errorImg: customErrorImg, labelsPosition, favouriteIconPosition } = settings;

            const maxImages = settings.max || 1;
            const offerImages = ref(images.slice(0, maxImages));

            let isLocalErrorImg = !customErrorImg;

            const getErrorImg = () => {
                if (isLocalErrorImg) {
                    return require('@/core/assets/images/no-photo.png');
                } else {
                    return customErrorImg;
                }
            };

            const createImagesCache = async () => {
                const imagesCache = [...offerImages.value.slice(1)];

                const onErrorImage = (i) => {
                    imagesCache[i] = getErrorImg();
                };

                const loadingImagePromises = imagesCache.map((imageForCache, i) => {
                    return new Promise((resolve) => {
                        const image = new Image();
                        image.src = imageForCache;

                        image.onload = resolve;

                        image.onerror = () => {
                            onErrorImage(i);
                            resolve();
                        };
                    });
                });

                await Promise.all(loadingImagePromises);

                offerImages.value = [offerImages.value[0], ...imagesCache];
            };

            if (!offerImages.value.length) {
                offerImages.value.push(getErrorImg());
            } else if (offerImages.value.length > 1) {
                createImagesCache();
            }

            const currentImageIndex = useImageController(refs, offerImages.value, props.mobile);

            const errorImgListener = (event) => {
                event.target.src = getErrorImg();

                // Если нет кастомной картинки или она не загрузилась
                if (!isLocalErrorImg) {
                    isLocalErrorImg = true;
                }
            };

            return {
                currentImageIndex,
                iconLike,
                iconEyeSlash,
                offerImages,
                labelsPosition,
                favouriteIconPosition,
                style,
                errorImgListener,
            };
        },
    };
</script>
